export { Divider } from './Divider';
export type { DividerProps } from './Divider';
